import { NgModule } from '@angular/core';
import { IconComponent } from './icon';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [IconComponent],
    exports: [IconComponent],
    imports: [FormsModule],
})
export class IconModule {
}